import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { DistributionRegionFilterRequest, DistributionRegionSaveRequest } from "@/main/models/request";
import { DistributionRegionResponse } from "@/main/models/response";

export abstract class IDistributionRegionApi {
	abstract getDistributions(
		request: DistributionRegionFilterRequest,
	): Promise<AxiosResponse<Result<DistributionRegionResponse[]>>>;
	abstract getDomain(request: DistributionRegionFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract saveRegion(
		request: DistributionRegionSaveRequest,
	): Promise<AxiosResponse<Result<DistributionRegionResponse>>>;
}
